var module = angular.module('octopusApp.shared');

module.service('actionTemplateProcessor', function ($location, octopusRepository, octopusPermissionSet, $q) {

    this.installCommunityActionTemplate = function(communityActionTemplate, getRedirectUrl, includeInstallStepIdInUrl, busy) {

        var promise = octopusRepository.CommunityActionTemplates.install(communityActionTemplate)
            .then(function(actionTemplate) {
                var url = getRedirectUrl(actionTemplate);

                if (includeInstallStepIdInUrl) {
                    $location.path(url).search('installedStep', actionTemplate.Id);
                }
                else {
                    $location.path(url);
                }
            });

        return busy.promise(promise);
    };

    this.cloneActionTemplate = function(actionTemplate, actionTemplateNameOverride, getRedirectUrl, busy, afterRedirect) {

        var newTemplate = {
            Name: actionTemplateNameOverride ? actionTemplateNameOverride : actionTemplate.Name,
            Description: actionTemplate.Description,
            ActionType: actionTemplate.ActionType,
            Properties: actionTemplate.Properties,
            Parameters: actionTemplate.Parameters,
            Version : actionTemplate.Version
        };

        var promise = octopusRepository.ActionTemplates.create(newTemplate)
            .then(function(actionTemplate) {
                var url = getRedirectUrl(actionTemplate);
                $location.path(url);
                afterRedirect();
            });

        return busy.promise(promise);
    };

    this.updateCommunityActionTemplateInstallation = function(communityActionTemplate, getRedirectUrl, busy) {

        var promise = octopusRepository.CommunityActionTemplates.updateInstallation(communityActionTemplate)
            .then(function(actionTemplate) {
                if (getRedirectUrl) {
                    var url = getRedirectUrl(actionTemplate);
                    $location.path(url);
                }
            });
        return busy.promise(promise);
    };

    this.getActionTemplates = function() {

        // Strictly speaking not required but the React warning was annoying enough :)
        // https://facebook.github.io/react/docs/multiple-components.html
        function provideRenderKey(templates) {
            for (var i = 0; i < templates.length; i++) {
                templates[i].key = i;
            }
        }

        var stepTemplateLoader = octopusRepository.ActionTemplates.search();

        return stepTemplateLoader.then(function (templates) {
            provideRenderKey(templates);
            return templates;
        });

    };

    this.getActionTemplatesAuthorizationAndFeatureConfig = function() {

        var permissionLoader = octopusPermissionSet.isAuthorized({permission: 'ActionTemplateView'});
        var featureConfigLoader = octopusRepository.FeaturesConfiguration.get();
        var loaders = [permissionLoader, featureConfigLoader];

        return $q.all(loaders).then(function (results) {

            var isAuthorized = results[0];
            var configuration = results[1];

            return {
                isAuthorized: isAuthorized,
                configuration: configuration
            };
        });

    };

    this.filterActionTemplates = function (templates, filterText, sectionScope) {

        var sectionTemplates = templates.filter(sectionScope);

        if (!filterText) {
            return sectionTemplates;
        }

        function contains(content, value) {
            return content && content.toLowerCase().indexOf(value) !== -1;
        }

        filterText = filterText.toLowerCase();

        return sectionTemplates.filter(function (template) {
            return contains(template.Name, filterText) ||
                contains(template.Category, filterText) ||
                contains(template.Description, filterText);
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/action_template_processor.js
// module id = 2476265238447425
// module chunks = 1